import { Injectable, Injector } from "@angular/core";
import { Service } from "@services/service";

@Injectable()
export class AssetTypeService extends Service {
	constructor(injector: Injector) {
		super("AssetType", injector);
	}
}